module.exports = __webpack_public_path__ + "img/geogebra.c6eae782.svg";